import React from 'react';
import cn from 'classnames';
import ChangeViewButton from '../ChangeViewButton/ChangeViewButton';
import { views } from '../../constants/views';
import ChoosePeriod from '../ChoosePeriod/ChoosePeriod';
import ChangeMode from '../ChangeMode/ChangeMode';
import { states } from '../../constants/states';
import AddTaskButton from '../AddTaskButton/AddTaskButton';
import ToggleOwner from '../ToggleOwner/ToggleOwner';
import { useCalendarState } from '../../context/CalendarContext';
import styles from './CalendarHeader.module.scss';
import commonStyles from '../../Calendar.module.scss';

const Header = ({
  rootClassName,
  choosePeriodRootClassName,
  showViewControls = true,
  showOwnerToggle = true,
  showModeControls = true,
}) => {
  const { state } = useCalendarState();

  return (
    <div className={cn(styles.root, rootClassName)}>
      <div className={styles.container}>
        <ChoosePeriod
          rootClassName={cn(styles.choosePeriod, choosePeriodRootClassName)}
        />
        {state === states.addTask && <AddTaskButton />}
      </div>

      {showViewControls && (
        <div className={commonStyles.flexContainer}>
          <ChangeViewButton view={views.day} text="День" />
          <ChangeViewButton view={views.week} text="Неделя" />
          <ChangeViewButton view={views.month} text="Месяц" />
        </div>
      )}

      {(showOwnerToggle || showModeControls) && (
        <div className={commonStyles.flexContainer}>
          {showOwnerToggle && <ToggleOwner />}
          {showModeControls && <ChangeMode />}
        </div>
      )}
    </div>
  );
};

export default Header;
